import { Injectable } from '@angular/core';
import { MenuItem } from 'src/app/views/layout/sidebar/menu.model';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  menuItems: MenuItem[] = [];
  userDataAuth: any;
  isConteinsRoles = false;
}
